import React from 'react';
import { Check } from 'lucide-react';
const BULLETS = ['Required files collected', 'Documents reviewed for completeness', 'Dispatch documents and profiles set up', 'Follow-up for missing or unreadable items'];
export function CleanerOnboarding() {
  return <section className="section-padding bg-white border-t border-steel" data-id="element-46">
      <div className="container-custom" data-id="element-47">
        <div className="grid lg:grid-cols-[1fr_minmax(380px,460px)] gap-10 lg:gap-14 items-center" data-id="element-48">
          {/* Left: heading, paragraph, checklist */}
          <div data-id="element-49">
            <h2 className="text-3xl md:text-4xl font-black text-navy mb-4 tracking-tight" data-id="element-50">
              Cleaner Onboarding Means Fewer Delays Before Trucks Start Running
            </h2>
            <p className="text-lg text-body font-medium leading-relaxed mb-8" data-id="element-51">
              Dispatch support only works when documents, company details,
              broker setup, and operating information are handled clearly. FSG
              helps collect and organize what is needed so the truck can start
              moving faster and avoid avoidable paperwork delays.
            </p>
            <ul className="grid sm:grid-cols-2 gap-4" data-id="element-52">
              {BULLETS.map((b, i) => <li key={i} className="flex items-center gap-3 bg-off-white border border-steel rounded-sm px-5 py-4" data-id="element-53">
                  <Check className="w-5 h-5 text-red shrink-0" data-id="element-54" />
                  <span className="font-semibold text-navy" data-id="element-55">{b}</span>
                </li>)}
            </ul>
          </div>

          {/* Right: onboarding checklist visual */}
          <div className="hidden md:flex justify-center lg:justify-end" data-id="element-56">
            <img src="https://cdn.magicpatterns.com/uploads/jpxdFtsmM6GZ65czsPrw3p/fsg-cleaner-onboarding-checklist.svg" alt="Carrier onboarding checklist and document setup illustration" className="w-full max-w-[460px] h-auto" data-id="element-57" />
          </div>
        </div>
      </div>
    </section>;
}